// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import SwiperCore, { Swiper, Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/core';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/swiper-bundle.css';
import './_featured-collection.scss';

// Install modules
SwiperCore.use([Swiper, Navigation, Pagination, Scrollbar, A11y, Keyboard]);

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--featured-collection").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("featured-collection-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.featured-collection').find(".swiper-button-prev").addClass("featured-collection-btn-prev-" + index);
    $this.parents('.featured-collection').find(".swiper-button-next").addClass("featured-collection-btn-next-" + index);

     // Generate unique btn classes for swiper pagination
     $this.parents('.featured-collection').find(".swiper-pagination").addClass("featured-collection-swiper-pagination-" + index);


    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".featured-collection-instance-" + index, {
        // Optional parameters
        slidesPerView: 2,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 4,
            spaceBetween: 15
          }
        },

        // // Navigation arrows
        navigation: {
          nextEl: ".featured-collection-btn-next-" + index,
          prevEl: ".featured-collection-btn-prev-" + index
        },
        pagination: {
            el: ".featured-collection-swiper-pagination-" + index,
            type: 'bullets',
            clickable: true,
        }
    });

    swiper.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
  });
});
